import { Routes } from '@angular/router';
import { TravelInsuranceRoutesEnum } from '../travel-insurance.routes.enum';
import { KnowledgebaseRoutesEnum } from './knowledgebase-routes.enum';

export const knowledgebaseRoutes: Routes = [
    {
        path: KnowledgebaseRoutesEnum.WintersportCoverage,
        pathMatch: 'full',
        loadChildren: () => import('./wintersport-dekking/wintersport-dekking.module').then((m) => m.WintersportDekkingModule),
    },
    {
        path: KnowledgebaseRoutesEnum.WorldwideCoverage,
        pathMatch: 'full',
        loadChildren: () => import('./wereldwijde-dekking/wereldwijde-dekking.module').then((m) => m.WereldwijdeDekkingModule),
    },
    {
        path: KnowledgebaseRoutesEnum.WhyIsATravelInsuranceNeeded,
        pathMatch: 'full',
        loadChildren: () => import('./waarom-reisverzekering-nodig/waarom-reisverzekering-nodig.module').then((m) => m.WaaromReisverzekeringNodigModule),
    },
    {
        path: KnowledgebaseRoutesEnum.CompareTravelInsurance,
        pathMatch: 'full',
        loadChildren: () => import('./vergelijken-reisverzekering/vergelijken-reisverzekering.module').then((m) => m.VergelijkenReisverzekeringModule),
    },
    {
        path: TravelInsuranceRoutesEnum.CancellationInsurance,
        children: [
            {
                path: KnowledgebaseRoutesEnum.IsCancellationInsuranceNeeded,
                loadChildren: () => import('./annuleringsverzekering/is-annuleringsverzekering-nodig/is-annuleringsverzekering-nodig.module').then((m) => m.IsAnnuleringsverzekeringNodigModule),
            },
            {
                path: KnowledgebaseRoutesEnum.NegativeTravelAdvise,
                loadChildren: () => import('./annuleringsverzekering/negatief-reisadvies/negatief-reisadvies.module').then((m) => m.NegatiefReisadviesModule),
            },
            {
                path: KnowledgebaseRoutesEnum.AirlineTicket,
                loadChildren: () => import('./annuleringsverzekering/vliegticket/vliegticket.module').then((m) => m.VliegticketModule),
            },
            {
                path: KnowledgebaseRoutesEnum.Comparison,
                loadChildren: () => import('./annuleringsverzekering/vergelijken/vergelijken.module').then((m) => m.VergelijkenModule),
            },
            {
                path: KnowledgebaseRoutesEnum.Requirements,
                loadChildren: () => import('./annuleringsverzekering/voorwaarden/voorwaarden.module').then((m) => m.VoorwaardenModule),
            },
            {
                path: KnowledgebaseRoutesEnum.Costs,
                loadChildren: () => import('./annuleringsverzekering/kosten/kosten.module').then((m) => m.KostenModule),
            },
            {
                path: KnowledgebaseRoutesEnum.PassingAway,
                loadChildren: () => import('./annuleringsverzekering/overlijden/overlijden.module').then((m) => m.OverlijdenModule),
            },
        ],
    },
    {
        path: KnowledgebaseRoutesEnum.BusinessTravelInsurance,
        pathMatch: 'full',
        loadChildren: () => import('./zakelijke-reisverzekering/zakelijke-reisverzekering.module').then((m) => m.ZakelijkeReisverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.Costs,
        pathMatch: 'full',
        loadChildren: () => import('./kosten/kosten.module').then((m) => m.KostenModule),
    },
    {
        path: KnowledgebaseRoutesEnum.ContinuousTravelInsurance,
        pathMatch: 'full',
        loadChildren: () => import('./doorlopende-reisverzekering/doorlopende-reisverzekering.module').then((m) => m.DoorlopendeReisverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.ShortTermTravelInsurance,
        pathMatch: 'full',
        loadChildren: () => import('./kortlopende-reisverzekering/kortlopende-reisverzekering.module').then((m) => m.KortlopendeReisverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.WintersportInsurance,
        pathMatch: 'full',
        loadChildren: () => import('./wintersportverzekering/wintersportverzekering.module').then((m) => m.WintersportverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.WintersportInsurance,
        pathMatch: 'full',
        loadChildren: () => import('./wintersportverzekering/wintersportverzekering.module').then((m) => m.WintersportverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.TemporaryTravelInsurance,
        pathMatch: 'full',
        loadChildren: () => import('./tijdelijke-reisverzekering/tijdelijke-reisverzekering.module').then((m) => m.TijdelijkeReisverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.Globetrotter,
        pathMatch: 'full',
        loadChildren: () => import('./globetrotter/globetrotter.module').then((m) => m.GlobetrotterModule),
    },
    {
        path: KnowledgebaseRoutesEnum.Repatriation,
        pathMatch: 'full',
        loadChildren: () => import('./repatriering/repatriering.module').then((m) => m.RepatrieringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.EmergencyAidAbroad,
        pathMatch: 'full',
        loadChildren: () => import('./spoedeisende-hulp-buitenland/spoedeisende-hulp-buitenland.module').then((m) => m.SpoedeisendeHulpBuitenlandModule),
    },
    {
        path: KnowledgebaseRoutesEnum.Europe,
        pathMatch: 'full',
        loadChildren: () => import('./europa/europa.module').then((m) => m.EuropaModule),
    },
    {
        path: KnowledgebaseRoutesEnum.ElderlyTravelInsurance,
        pathMatch: 'full',
        loadChildren: () =>
            import('./ouderen-65-plussers-reisverzekering/ouderen-65-plussers-reisverzekering.module')
                .then((m) => m.Ouderen65PlussersReisverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.BlendedFamiliesTravelInsurance,
        pathMatch: 'full',
        loadChildren: () =>
            import('./samengestelde-gezinnen-reisverzekering/samengestelde-gezinnen-reisverzekering.module')
                .then((m) => m.SamengesteldeGezinnenReisverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.ScubaDivingTravelInsurance,
        pathMatch: 'full',
        loadChildren: () =>
            import('./duikers-duiksport-reisverzekering/duikers-duiksport-reisverzekering.module')
                .then((m) => m.DuikersDuiksportReisverzekeringModule),
    },
    {
        path: KnowledgebaseRoutesEnum.MedicalCostsAbroad,
        pathMatch: 'full',
        loadChildren: () =>
            import('./medische-kosten-buitenland/medische-kosten-buitenland.module')
                .then((m) => m.MedischeKostenBuitenlandModule),
    },
];
